// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"InfoCard-module__infoContainer___1J_3R","imageContainer":"InfoCard-module__imageContainer___2cvT7","details":"InfoCard-module__details___3QqKs"};